import { render } from "./BottomBoard.vue?vue&type=template&id=3329d206"
import script from "./BottomBoard.vue?vue&type=script&lang=js"
export * from "./BottomBoard.vue?vue&type=script&lang=js"

import "./BottomBoard.vue?vue&type=style&index=0&id=3329d206&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__